import { render, staticRenderFns } from "./LayoutCentered.vue?vue&type=template&id=66a004ab&scoped=true&"
import script from "./LayoutCentered.vue?vue&type=script&lang=js&"
export * from "./LayoutCentered.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCentered.vue?vue&type=style&index=0&id=66a004ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a004ab",
  null
  
)

export default component.exports